import { render, staticRenderFns } from "./TherapyBookingCard.vue?vue&type=template&id=21d373f3"
import script from "./TherapyBookingCard.vue?vue&type=script&lang=js"
export * from "./TherapyBookingCard.vue?vue&type=script&lang=js"
import style0 from "./TherapyBookingCard.vue?vue&type=style&index=0&id=21d373f3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports